import React, { useState, useEffect } from 'react';
import { StoreDetails } from '../../types';
import './StoreInfo.css';

interface StoreInfoProps {
  storeDetails: StoreDetails;
  onStoreDetailsChange: (storeDetails: StoreDetails) => void;
  isEditing?: boolean;
  onEditToggle?: () => void;
}

const StoreInfo: React.FC<StoreInfoProps> = ({
  storeDetails,
  onStoreDetailsChange,
  isEditing = false,
  onEditToggle = () => {}
}) => {
  const [localStoreDetails, setLocalStoreDetails] = useState<StoreDetails>(storeDetails);

  // Update local state when props change
  useEffect(() => {
    setLocalStoreDetails(storeDetails);
  }, [storeDetails]);

  const handleStoreInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLocalStoreDetails(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStoreDetailsChange(localStoreDetails);
    onEditToggle();
  };

  if (!isEditing) {
    return (
      <div className="store-info-display">
        <h2>Store Information</h2>
        <p><strong>Name:</strong> {storeDetails.name}</p>
        <p><strong>Address:</strong> {storeDetails.address}</p>
        <p><strong>Phone:</strong> {storeDetails.phone}</p>
        {storeDetails.email && <p><strong>Email:</strong> {storeDetails.email}</p>}
        {storeDetails.website && <p><strong>Website:</strong> {storeDetails.website}</p>}
        
        <button 
          type="button" 
          className="edit-button"
          onClick={onEditToggle}
        >
          Edit Store Info
        </button>
      </div>
    );
  }

  return (
    <div className="store-info-container">
      <form onSubmit={handleSubmit} className="store-info-form">
        <div className="store-info-section">
          <h2>Store Information</h2>
          <div className="form-group">
            <label htmlFor="name">Store Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={localStoreDetails.name}
              onChange={handleStoreInfoChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              id="address"
              name="address"
              value={localStoreDetails.address}
              onChange={handleStoreInfoChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={localStoreDetails.phone}
              onChange={handleStoreInfoChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email (Optional)</label>
            <input
              type="email"
              id="email"
              name="email"
              value={localStoreDetails.email || ''}
              onChange={handleStoreInfoChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="website">Website (Optional)</label>
            <input
              type="text"
              id="website"
              name="website"
              value={localStoreDetails.website || ''}
              onChange={handleStoreInfoChange}
            />
          </div>
          <div className="form-actions">
            <button 
              type="button" 
              className="secondary-button" 
              onClick={onEditToggle}
            >
              Cancel
            </button>
            <button type="submit" className="primary-button">
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default StoreInfo;
